/**
 * SELECT BUTTON TOKENS
 * Source: 🎨 Figma — components-rentals export
 *
 * Custom additions are marked with "Custom" comments below.
 */

import { type SemanticTokens, SEMANTIC } from '../semantic.js';

export function createSelectButtonTokens(s: SemanticTokens) {
  return {
  // ──── Figma tokens ────

  /** Base spacing for select buttons */
  base: {
    paddingX: s.layout.gap.sm,  // --select-button-base-padding-x: var(--spacing-8)
    paddingY: s.layout.gap.sm,  // --select-button-base-padding-y: var(--spacing-8)
    gap: s.layout.gap.sm,       // --select-button-base-gap: var(--spacing-8)
    radius: s.radius.md,        // --select-button-base-radius: var(--radius-8)
    fontWeight: s.typography.fontWeight.bold,  // --select-button-base-font-weight
    fontSize: s.typography.fontSize.base,      // --select-button-base-font-size
    lineHeight: s.typography.lineHeight.normal, // --select-button-base-line-height
    transition: s.transition.normal,              // --select-button-base-transition
  },
  bg: s.surface.raised,                      // --select-button-item-bg: var(--surface-raised)
  fg: s.text.tertiary,                       // --select-button-item-fg: var(--text-tertiary)
  trackOn: s.surface.ground,                 // --select-button-item-track-on: var(--surface-ground)
  trackDisabled: s.surface.disabled,         // --select-button-item-track-disabled: var(--surface-disabled)
  fgActive: s.text.secondary,               // --select-button-item-fg---active: var(--text-secondary)
  fgDisabled: s.text.onColor,                // --select-button-item-fg-disabled: var(--text-on-color)

  // ──── Custom tokens (not in Figma) ────

  bgHover: s.surface.canvas,                 // --select-button-item-bg-hover: var(--surface-canvas)
  };
}
export const selectButtonTokens = createSelectButtonTokens(SEMANTIC);